import* as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useFormik } from 'formik';
import { Button, Stack, TextField, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import { API_URL, FILE_UPLOAD_TYPE, OWNERSHIP_TYPE } from '../constant';
import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../context/logincontext'
import { isEmpty } from 'lodash';
import Styles from '../css/dates.module.css'
import Iconify from '../components/Iconify';

/// ----------------------------------------------------------------------
const phoneRegExp = /^([0-9]){10}?$/
const aadhaarRegex = /^([0-9]){4}([0-9]){4}([0-9]){4}?$/
const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/
const pinRegExp = /^([0-9]){6}?$/

const validationSchemaDetails = yup.object({
    mobile: yup.string().matches(phoneRegExp, 'Phone number is not valid').required('field cannot be empty'),
    pin_code: yup.string().matches(pinRegExp, 'Pincode is not valid').required('field cannot be empty'),
    name: yup.string().required('field cannot be empty').matches(/^[A-Za-z\s]*$/, 'Name must contain only letters and spaces'),
    dob: yup.date().required('This field is required'),
    gender: yup.number().required('This field is required'),
    type: yup.string().required('This field is required'),
    aadhaar_no: yup.string().matches(aadhaarRegex, 'Aadhaar number is not valid').required('This field is required'),
    pan: yup.string().matches(panRegex, 'Pan number is not valid').required('This field is required'),
    address: yup.string().required('This field is required'),
    amount: yup.number().min(5000, 'Amount must be at least 5000').required('Amount is required'),
    dealer_branch_id: yup.number().required('Company Branch is required'),
    ownership_type: yup.string().required('Ownership Type is required')
});


export default function AddLead() {
    const [pin, setPin] = useState('')
    const [aadharCard, setAadhaarCard] = useState(undefined)
    const [panCard, setPanCard] = useState(undefined)
    const [branches, setBranches] = useState([])
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const context = useContext(LoginContext)

    const formik = useFormik({
        initialValues: {
            name: '',
            mobile: '',
            aadhaar_no: '',
            pan: '',
            address: '',
            city: '',
            dob: '',
            gender: 1,
            user_id: context?.user?.user_id,
            dealer_id: context?.user?.company?.dealer_id,
            type: 'E-Rickshaw',
            amount: 0,
            state: '',
            pin_code:'',
            ownership_type:'',
            dealer_branch_id: null,
            branch_id: null,
            branch_name: ''
        },
        validationSchema: validationSchemaDetails,
        onSubmit: async (values) => {
            setLoading(true);
            await submitForm(values);
            setLoading(false);
        },
    });

    async function submitForm(value) {

        const formattedValues = {
            ...value,
            pincode: Number(value.pin_code),
            street1: value.address,
            aadhar_no : Number(value.aadhaar_no)
        };

        const data = new FormData();
        const files = []
        if (!isEmpty(aadharCard)) {
            for (let doc of aadharCard) {
                files.push({ fileType: FILE_UPLOAD_TYPE.AADHAR, file: doc })
            }
        }

        if (!isEmpty(panCard)) {
            for (let doc of panCard) {
                files.push({ fileType: FILE_UPLOAD_TYPE.PAN, file: doc })
            }
        }

        data.append('data', JSON.stringify(formattedValues));
        files.forEach((file) => {
            data.append(file.fileType, file.file);
        })
        
        const response = await axios.post(`${API_URL}/lead`, data);
        if (response.data.status === 'success') {
            navigate('/dashboard/leads');
        }
    }

    const Input = styled('input')({
        display: 'none',
    });

    const handleAadhaarCard = (e) => {
        setAadhaarCard(Object.values(e.target.files))
    }
    const handlePanCard = (e) => {
        setPanCard(Object.values(e.target.files))
    }

    const handlePinChange = async (e) => {
        setPin(e.target.value)
        if ((e.target.value).length > 5) {
            formik.setFieldValue('pin_code', e.target.value)
            const response = await axios.get(`${API_URL}/get_city_by_pin/${e.target.value}`);
            if (!isEmpty(response?.data?.data)) {
                formik.setFieldValue('city', response?.data?.data?.district_name)
                formik.setFieldValue('state', response?.data?.data?.state_name)
            }
        } else {
            formik.setFieldValue('city', '')
            formik.setFieldValue('state', '')
        }
    }

    const handleBranchChange = async (e) => {
        const dealerBranchId = e.target.value
        const branchData =  branches.find(branch => branch.id = dealerBranchId)
        formik.setFieldValue('dealer_branch_id', e.target.value)
        formik.setFieldValue('branch_id', branchData.branch_id )
        formik.setFieldValue('branch_name', branchData.branch_name)
    }

    useEffect(() => {
        const dealerId = context?.user?.company?.dealer_id;
        if (dealerId) {
            getDealerBranches(dealerId);
        }
    }, [context?.user?.company?.dealer_id]);

    const getDealerBranches = async(dealerId) => {
        const response = await axios.get(`${API_URL}/dealers/${dealerId}/branches`);
        if (!isEmpty(response?.data?.data)) {
            setBranches(response.data.data)
        }
    }

    return (
        <div>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mt={5}>
                <Typography style={{ paddingLeft: '20px' }} variant="h4" gutterBottom>
                    Add Customer
                </Typography>
            </Stack>
            <form onSubmit={formik.handleSubmit}>
                <Box sx={{ flexGrow: 1, p: 2 }}>
                    <Grid container spacing={2} justifyContent='center'>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                autoComplete='off'
                                fullWidth
                                name="name"
                                type="text"
                                label="Name*"
                                inputProps={{ style: { textTransform: "uppercase" } }}
                                onBlur={() => formik.setFieldValue('name', (formik.values.name).toUpperCase())}
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && formik.errors.name}
                            />
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                autoComplete='off'
                                fullWidth
                                name="mobile"
                                inputProps={{ maxLength: 10 }}
                                label="Mobile Number*"
                                value={formik.values.mobile}
                                onChange={formik.handleChange}
                                error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                                helperText={formik.touched.mobile && formik.errors.mobile}
                            />
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                fullWidth
                                select
                                labelId="gender"
                                id="gender"
                                name="gender"
                                label="Gender*"
                                value={formik.values.gender}
                                onChange={formik.handleChange}
                                error={formik.touched.gender && Boolean(formik.errors.gender)}
                                helpertext={formik.touched.gender && formik.errors.gender}
                            >
                                <MenuItem value={1}>Male</MenuItem>
                                <MenuItem value={2}>Female</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                autoComplete='off'
                                fullWidth
                                name="dob"
                                type={'date'}
                                label="DOB*"
                                className={formik.values.dob === null && Styles.dates}
                                value={formik.values.dob}
                                onChange={formik.handleChange}
                                error={formik.touched.dob && Boolean(formik.errors.dob)}
                                helperText={formik.touched.dob && formik.errors.dob}
                            />
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                fullWidth
                                select
                                labelId="type"
                                id="type"
                                name="type"
                                label="Lead Type*"
                                value={formik.values.type}
                                onChange={formik.handleChange}
                                error={formik.touched.type && Boolean(formik.errors.type)}
                                helpertext={formik.touched.type && formik.errors.type}
                            >
                                <MenuItem value={'E-Rickshaw'}>E-Rickshaw</MenuItem>
                                <MenuItem value={'Battery'}>Battery</MenuItem>
                                <MenuItem value={'L5'}>L5</MenuItem>
                                <MenuItem value={'E4W'}>E4W</MenuItem>
                                <MenuItem value={'E-Bike'}>E-Bike</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                autoComplete='off'
                                fullWidth
                                name="amount"
                                label="Amount Requested*"
                                value={formik.values.amount}
                                onChange={formik.handleChange}
                                error={formik.touched.amount && Boolean(formik.errors.amount)}
                                helperText={formik.touched.amount && formik.errors.amount}
                            />
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                                <TextField
                                    fullWidth
                                    autoComplete='off'
                                    inputProps={{ maxLength: 12 }}
                                    name="aadhaar_no"
                                    label="Aadhaar number*"
                                    value={formik.values.aadhaar_no}
                                    onChange={formik.handleChange}
                                    error={formik.touched.aadhaar_no && Boolean(formik.errors.aadhaar_no)}
                                    helperText={formik.touched.aadhaar_no && formik.errors.aadhaar_no}
                                />
                                <div style={{ display: 'flex', flexDirection: 'column', width: '30%', alignItems: 'center' }}>
                                    <label htmlFor="aadhaar_file_path" style={{ paddingLeft: 10 }}>
                                        <Input accept="image/*,application/pdf" id="aadhaar_file_path" type="file" multiple onChange={handleAadhaarCard} />
                                        <Iconify icon="entypo:upload" sx={{ color: aadharCard ? 'green' : 'black', fontSize: '25px', cursor: 'pointer', verticalAlign: 'middle', marginRight: '10px' }} />
                                    </label>
                                    <Typography style={{ textAlign: 'center', fontSize: '15px', color: aadharCard ? 'grey' : 'black' }}>Upload Aadhaar*</Typography>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                                <TextField
                                    fullWidth
                                    autoComplete='off'
                                    name="pan"
                                    label="Pan Number*"
                                    inputProps={{ maxLength: 10, style: { textTransform: "uppercase" } }}
                                    onBlur={() => formik.setFieldValue('pan', (formik.values.pan).toUpperCase())}
                                    value={formik.values.pan}
                                    onChange={formik.handleChange}
                                    error={formik.touched.pan && Boolean(formik.errors.pan)}
                                    helperText={formik.touched.pan && formik.errors.pan}
                                />
                                <div style={{ display: 'flex', flexDirection: 'column', width: '30%', alignItems: 'center' }}>
                                    <label htmlFor="pan_file_path" style={{ paddingLeft: 10 }}>
                                        <Input accept="image/*,application/pdf" id="pan_file_path" type="file" multiple onChange={handlePanCard} />
                                        <Iconify icon="entypo:upload" sx={{ color: panCard ? 'green' : 'black', fontSize: '25px', cursor: 'pointer', verticalAlign: 'middle', marginRight: '10px' }} />
                                    </label>
                                    <Typography style={{ textAlign: 'center', fontSize: '15px', color: panCard ? 'grey' : 'black' }}>Upload Pan*</Typography>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                autoComplete='off'
                                fullWidth
                                name="address"
                                label="Address*"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                error={formik.touched.address && Boolean(formik.errors.address)}
                                helperText={formik.touched.address && formik.errors.address}
                            />
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                autoComplete='off'
                                fullWidth
                                name="pin_code"
                                label="Pin Code*"
                                inputProps={{ maxLength: 6 }}
                                value={pin}
                                onChange={handlePinChange}
                                error={formik.touched.pin_code && Boolean(formik.errors.pin_code)}
                                helperText={formik.touched.pin_code && formik.errors.pin_code}
                            />
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                autoComplete='off'
                                fullWidth
                                name="city"
                                label="City*"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                error={formik.touched.city && Boolean(formik.errors.city)}
                                helperText={formik.touched.city && formik.errors.city}
                            />
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                autoComplete='off'
                                fullWidth
                                name="state"
                                label="State*"
                                value={formik.values.state}
                                onChange={formik.handleChange}
                                error={formik.touched.state && Boolean(formik.errors.state)}
                                helperText={formik.touched.state && formik.errors.state}
                            />
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                fullWidth
                                select
                                labelId="dealer_branch_id"
                                id="dealer_branch_id"
                                name="dealer_branch_id"
                                label="Company Branch*"
                                value={formik.values.dealer_branch_id}
                                onChange={handleBranchChange}
                                error={formik.touched.dealer_branch_id && Boolean(formik.errors.dealer_branch_id)}
                                helpertext={formik.touched.dealer_branch_id && formik.errors.dealer_branch_id}
                            >
                                {branches && branches?.map(branch =>  (<MenuItem value={branch.id} key={branch.id}>{branch.branch_name}</MenuItem>))}
                                
                            </TextField>
                        </Grid>
                        <Grid item xs={11} sm={6}>
                            <TextField
                                fullWidth
                                select
                                labelId="ownership_type"
                                id="ownership_type"
                                name="ownership_type"
                                label="Ownership*"
                                value={formik.values.ownership_type}
                                onChange={formik.handleChange}
                                error={formik.touched.ownership_type && Boolean(formik.errors.ownership_type)}
                                helpertext={formik.touched.ownership_type && formik.errors.ownership_type}
                            >
                                {OWNERSHIP_TYPE?.map((type, index) => (<MenuItem key={index} value={type}> {type} </MenuItem> ))}
                            </TextField>
                        </Grid>
                    </Grid>
                </Box>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                    <Button variant="contained" type="submit" sx={{width: '16%', marginTop: 10, fontSize: 18 }} disabled={loading}> {loading ? "Submitting..." : "Submit"} </Button>
                </div>
            </form>
        </div>
    );
}